export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const BASE_PRICE = 24.9;

// Ordinati dal prezzo più basso al più alto (anchoring / valore crescente)
const ALL_PRODUCTS = [
  // Card Smart Google Recensioni (prime in fila): Standard senza logo, Premium con logo personalizzato
  { id: "smart_std_blue", price: 19.99, extra: null, smart: true, pick: true, preset: "royal", noLogo: true, image: "/assets/std-blue.webp", style: { radius: 14, gloss: true } },
  { id: "smart_std_black", price: 19.99, extra: null, smart: true, preset: "onyx", noLogo: true, image: "/assets/std-black.webp", style: { radius: 14, gloss: true } },
  { id: "smart_prem_blue", price: 24.99, extra: 5.0, smart: true, preset: "royal", image: "/assets/prem-blue.webp", style: { radius: 14, gloss: true, frame: true } },
  { id: "smart_prem_black", price: 24.99, extra: 5.0, smart: true, preset: "onyx", image: "/assets/prem-black.webp", style: { radius: 14, gloss: true, frame: true } },
  { id: "pvc_gloss_standard", price: 24.9, extra: null, pvc: true, image: "/assets/pvc-gloss.webp", style: { radius: 14, finish: "gloss" } },
  { id: "pvc_eco_recycled", price: 27.9, extra: 3.0, pvc: true, image: "/assets/pvc-eco.webp", style: { radius: 14, finish: "eco" } },
  { id: "pvc_matte_premium", price: 29.9, extra: 5.0, pvc: true, image: "/assets/pvc-matte.webp", style: { radius: 14, finish: "matte", frame: true } },
  { id: "pvc_crystal_clear", price: 34.9, extra: 10.0, pvc: true, image: "/assets/pvc-crystal.webp", style: { radius: 14, finish: "crystal", frame: true } },
  // Legacy (ordini esistenti): non mostrati nel configuratore
  { id: "card_standard", price: 24.9, extra: null, hidden: true, image: "/assets/card-blue-ai.webp", style: { radius: 14, gloss: true } },
  { id: "card_premium", price: 34.9, extra: 10.0, hidden: true, image: "/assets/card-blue.webp", style: { radius: 14, gloss: true, frame: true } },
  { id: "smart_business_card", price: 39.9, extra: 15.0, portrait: true, image: "/assets/card-biz-ai.webp", style: { radius: 10, gloss: true } },
  { id: "card_boutique_wood", price: 54.9, extra: null, material: "wood", image: "/assets/boutique-wood-ai.webp", style: { radius: 8, engraved: true } },
  { id: "card_boutique_steel", price: 64.9, extra: null, material: "steel", image: "/assets/boutique-steel-ai.webp", style: { radius: 8, engraved: true } },
  { id: "kit_3_premium", price: 79.9, extra: null, kit: true, image: "/assets/card-black-ai.webp", style: { radius: 14, gloss: true, frame: true } },
];

// Keep retired IDs for historical orders, but expose just the two current models.
export const PRODUCTS = ALL_PRODUCTS.map((p) => ({ ...p, hidden: !["smart_std_blue", "smart_prem_blue"].includes(p.id) }));
export const ACTIVE_PRODUCTS = PRODUCTS.filter((p) => !p.hidden);
export const currentProductId = (id) => id === "smart_std_black" ? "smart_std_blue" : id === "smart_prem_black" ? "smart_prem_blue" : ACTIVE_PRODUCTS.some((p) => p.id === id) ? id : "smart_std_blue";

export const LEGACY_PALETTES = [
  { id: "onyx", name: "Nero", bg: "linear-gradient(135deg,#252525,#111111)", text: "#FFFFFF", sub: "#E0E0E0" },
  { id: "pearl", name: "Bianco", bg: "linear-gradient(135deg,#FFFFFF,#EEEEEE)", text: "#171717", sub: "#454545" },
  { id: "royal", name: "Blu navy", bg: "linear-gradient(135deg,#203451,#101C30)", text: "#FFFFFF", sub: "#DEE6F2" },
  { id: "graphite", name: "Grigio", bg: "linear-gradient(135deg,#626262,#383838)", text: "#FFFFFF", sub: "#EEEEEE" },
  { id: "burgundy", name: "Bordeaux", bg: "linear-gradient(135deg,#672335,#3D111D)", text: "#FFFFFF", sub: "#F2DDE2" },
];

// Finiture native della linea Boutique (sostituiscono la palette)
export const MATERIALS = {
  wood: {
    id: "wood",
    bg: "repeating-linear-gradient(90deg, rgba(60,30,10,0.11) 0 1px, transparent 1px 9px), repeating-linear-gradient(90deg, rgba(255,236,200,0.10) 0 3px, transparent 3px 17px), linear-gradient(135deg,#C99A62 0%,#A97442 52%,#BE8B57 100%)",
    text: "#2B1A0E", sub: "#5C3D22", plate: "#FFF9F0",
  },
  steel: {
    id: "steel",
    bg: "repeating-linear-gradient(0deg, rgba(255,255,255,0.12) 0 1px, transparent 1px 3px), linear-gradient(135deg,#E9EBEF 0%,#A3ABB8 42%,#D5D9E0 70%,#8E98A8 100%)",
    text: "#111827", sub: "#374151", plate: "#FFFFFF",
  },
};

export const PALETTES = LEGACY_PALETTES.filter((palette) => ["royal", "onyx"].includes(palette.id)).map((palette) => ({ ...palette, bg: palette.id === "royal" ? "#3467d6" : "#191b20" }));

export const LAYOUTS = [
  { id: "classic", name: "Classico", desc: "Logo in alto, stelle al centro, QR in basso" },
  { id: "minimal", name: "Minimal", desc: "Massimo spazio bianco, tipografia essenziale" },
  { id: "lux", name: "Lusso", desc: "Composizione editoriale con accenti dorati" },
];

// Five curated typefaces; saved legacy font IDs resolve safely to Outfit.
export const FONTS = [
  { id: "outfit", name: "Outfit", family: "'Outfit', sans-serif", tone: "Geometrico" },
  { id: "playfair", name: "Playfair Display", family: "'Playfair Display', serif", tone: "Editoriale" },
  { id: "cormorant", name: "Cormorant Garamond", family: "'Cormorant Garamond', serif", tone: "Luxury" },
  { id: "montserrat", name: "Montserrat", family: "'Montserrat', sans-serif", tone: "Corporate" },
  { id: "raleway", name: "Raleway", family: "'Raleway', sans-serif", tone: "Raffinato" },
];

export const fontFamily = (id) => (FONTS.find((f) => f.id === id) || FONTS[0]).family;

export const assetUrl = (p) => (p ? (p.startsWith("/api") ? `${BACKEND_URL}${p}` : p) : null);

export const eur = (n) =>
  `€ ${n.toFixed(2).replace(".", ",")}`;

export const FREE_SHIPPING_FROM = 50;
export const STAND = { id: "display_stand_oak", price: 14.9, image: "/assets/stand-oak.webp" };
export const SHIPPING_PRICES = { standard: 6.9, express: 9.9, pickup_rimini: 0, pickup_cluj: 0 };
export const shippingCost = (method, netSubtotal) => {
  const base = SHIPPING_PRICES[method] ?? 0;
  return base > 0 && netSubtotal >= FREE_SHIPPING_FROM ? 0 : base;
};
